import type { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'
import type { StaffAccountStatusFilter } from '../staff/model'
import { deserialize } from 'ts-jackson'
import { PageInfo, PaginationOpt, PaginationResponse } from '../model'
import { TrainerUser, User } from './model'

export const UserService = (client: AxiosInstance) => {
  return {
    async getUsers(opt: PaginationOpt): Promise<PaginationResponse<User>> {
      const { data } = await wrapApiCall(() =>
        client.get<{ pagination: Record<string, unknown>; data: Record<string, unknown>[] }>(
          '/users',
          { params: opt }
        )
      )
      return {
        pagination: deserialize(data?.pagination, PageInfo),
        data: data?.data?.map((item: Record<string, unknown>) => deserialize(item, User)),
      }
    },
    async getUserTrainers(opt: PaginationOpt): Promise<PaginationResponse<TrainerUser>> {
      const { data } = await wrapApiCall(() =>
        client.get<{ pagination: Record<string, unknown>; data: Record<string, unknown>[] }>(
          '/users/trainers',
          { params: opt }
        )
      )
      return {
        pagination: deserialize(data?.pagination, PageInfo),
        data: data?.data?.map((item: Record<string, unknown>) => deserialize(item, TrainerUser)),
      }
    },
    async getTrainers(
      opt: PaginationOpt & { accountStatus?: StaffAccountStatusFilter }
    ): Promise<PaginationResponse<TrainerUser>> {
      const { data } = await wrapApiCall(() =>
        client.get<{ pagination: Record<string, unknown>; data: Record<string, unknown>[] }>(
          '/users/trainers',
          { params: opt }
        )
      )
      return {
        pagination: deserialize(data?.pagination, PageInfo),
        data: data?.data?.map((item: Record<string, unknown>) => deserialize(item, TrainerUser)),
      }
    },
    async getUserById(userId: number | string): Promise<User> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>>(`/users/${userId}`)
      )
      return deserialize(data, User)
    },
  }
}
